import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css";
import { Presets } from "./types";
import { isBefore } from "../../utils/date/checkers";
import { ptBR } from "../../utils/date/locale";
import { addDays } from "../../utils/date/operations";
import DatePickerDay from "./components/DatePickerDay";
import DatePickerHeader from "./components/DatePickerHeader";
import DatePickerPresets from "./components/DatePickerPresets";
import DatePickerTrigger from "./components/DatePickerTrigger";
const DatePicker = ({ startDate = new Date(), endDate = new Date(), minDate, maxDate, maxDays, presets, popperPlacement = "bottom-start", onChange, onCalendarOpen, onSelect, }) => {
    registerLocale("ptBR", ptBR);
    const [dateRange, setDateRange] = useState([startDate, endDate]);
    const [dateHover, setDateHover] = useState(null);
    const [open, setOpen] = useState(false);
    const [preset, setPreset] = useState(Presets.TODAY);
    const [maxEndDate, setMaxEndDate] = useState(maxDate);
    const [startRangeDate, endRangeDate] = dateRange;
    const handleDateChange = (range) => {
        setDateRange(range);
        if (range[0] && range[1])
            onChange(range);
        const end = range[1];
        if (end)
            setOpen(false);
    };
    const handleDateSelect = (date) => {
        if (!maxDays)
            return;
        const newEndDate = addDays(date, maxDays);
        const newMaxEndDate = isBefore(newEndDate, maxEndDate || new Date()) ? newEndDate : maxEndDate;
        setMaxEndDate(newMaxEndDate);
    };
    useEffect(() => {
        if (!open && endRangeDate)
            setMaxEndDate(maxDate);
    }, [open, endRangeDate, maxDate]);
    return (_jsx(ReactDatePicker
    // Base props
    , { 
        // Base props
        locale: "ptBR", portalId: "datepicker-portal", dateFormat: "dd/MM/yyyy", 
        // Date props
        open: open, selected: startRangeDate, startDate: startRangeDate, endDate: endRangeDate, selectsStart: true, selectsRange: true, monthsShown: 2, showPopperArrow: false, popperPlacement: popperPlacement, minDate: minDate, maxDate: maxEndDate, focusSelectedMonth: true, 
        // Methods
        onDayMouseEnter: setDateHover, onCalendarOpen: onCalendarOpen, onChange: handleDateChange, onSelect: onSelect || handleDateSelect, onChangeRaw: () => setPreset(null), onInputClick: () => setOpen(true), onClickOutside: () => setOpen(false), 
        // Custom elements
        formatWeekDay: (nameOfDay) => _jsx("div", { className: "font-bold text-gray", children: nameOfDay.toUpperCase().at(0) }), renderCustomHeader: DatePickerHeader, renderDayContents: (day, date) => _jsx(DatePickerDay, { day: day, date: date, startDate: startRangeDate, endDate: endRangeDate, dateHover: dateHover }), customInput: _jsx(DatePickerTrigger, { open: open }), children: _jsx(DatePickerPresets, { preset: preset, presets: presets, onChangePreset: setPreset, onChange: handleDateChange }) }));
};
export default DatePicker;
